import React, {useEffect} from "react";
import {CmmnHeader} from "../components/common/CmmnHeader";
import {Sub_top_002} from "../const/ConstImages";
import {EpinBody} from "../components/profile/EpinBody";

export const EpinScreen = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return(
        <div style={{
            backgroundColor: "white",
            height: "100%"
        }}>
            <CmmnHeader backgroundImg={Sub_top_002} title="Shop" />
            <EpinBody />
        </div>
    );
}
